var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.88184 8.25065V5.95898",
    stroke: "#0D0D0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99967 7.10352H3.70801",
    stroke: "#0D0D0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.16699 0.916016V2.29102",
    stroke: "#0D0D0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.83301 0.916016V2.29102",
    stroke: "#0D0D0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.74642 1.56836C9.27725 1.62336 10.0518 2.18711 10.0977 4.34128L10.1573 7.16919C10.1939 9.05753 9.7585 10.0063 7.46683 10.0567L4.71683 10.1117C2.42517 10.1575 1.9485 9.22253 1.91183 7.33878L1.84767 4.50628C1.80183 2.35211 2.55808 1.75628 4.07975 1.64169L7.74642 1.56836Z",
    stroke: "#0D0D0D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNoteIcon);
export default __webpack_public_path__ + "static/media/add-note-icon.8d914b01bf21abd67c39c0a7031845b9.svg";
export { ForwardRef as ReactComponent };